module.exports = __webpack_public_path__ + "img/6-meeting-and-seminars.daa310e0.png";